import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { m as marginPropTypes } from './spacing-7e57ffb0.js';
import { S as SvgIcon } from './SvgIcon-1308e965.js';

function IconEyeOff(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.367 10.309a2.668 2.668 0 0 1-3.676-3.676L3.992 4.934a11.631 11.631 0 0 0-2.563 3.068 12.38 12.38 0 0 0 1.641 2.209c1.448 1.544 3.1 2.456 4.919 2.456a6.05 6.05 0 0 0 2.925-.81zm-.995-.994L6.685 7.628a1.336 1.336 0 0 0 1.687 1.687zM7.055 6.113l.005.005 2.823 2.823.005.005 2.536 2.536.014.014 3.367 3.367a.668.668 0 0 1-.943.943l-2.978-2.978A7.389 7.389 0 0 1 8 14.001c-2.253 0-4.226-1.088-5.903-2.877A13.678 13.678 0 0 1 .596 9.196a10.221 10.221 0 0 1-.526-.897.664.664 0 0 1 .009-.613A12.97 12.97 0 0 1 3.045 3.99L.195 1.14a.668.668 0 0 1 .943-.943l3.366 3.366.014.014 2.537 2.537zm7.229 1.415a12.38 12.38 0 0 0-1.353-1.739c-1.448-1.544-3.1-2.456-4.932-2.456a5.437 5.437 0 0 0-1.246.142.667.667 0 0 1-.304-1.298 6.769 6.769 0 0 1 1.552-.178c2.253 0 4.226 1.088 5.903 2.877a13.678 13.678 0 0 1 1.501 1.928c.256.397.432.709.526.897a.665.665 0 0 1-.008.612 13.03 13.03 0 0 1-1.518 2.242.666.666 0 1 1-1.02-.858c.446-.53.844-1.099 1.189-1.699a11.97 11.97 0 0 0-.288-.47z"
  }));
}
IconEyeOff.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconEyeOff.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconEyeOff as default };
